// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';

export const toggleReportsAccordion = () => ({
    type: actions.TOGGLE_CLAIMS_REPORTS_ACCORDION
});



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/reports-accordion.js